var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.162,
    height: 42.1,
    viewBox: "0 0 38.162 42.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon1",
    transform: "translate(-2.95 0.05)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3502",
    "data-name": "Grupo 3502",
    transform: "translate(3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3478",
    "data-name": "Grupo 3478",
    transform: "translate(1.969 13.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11001",
    "data-name": "Caminho 11001",
    d: "M39.469,23.938H6.656A.656.656,0,0,1,6,23.281V20.656A.656.656,0,0,1,6.656,20H39.469a.656.656,0,0,1,.656.656v2.625A.656.656,0,0,1,39.469,23.938ZM7.313,22.625h31.5V21.313H7.313Z",
    transform: "translate(-6 -20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11001_-_Contorno",
    "data-name": "Caminho 11001 - Contorno",
    d: "M39.469,23.987H6.656a.707.707,0,0,1-.706-.706V20.656a.707.707,0,0,1,.706-.706H39.469a.707.707,0,0,1,.706.706v2.625A.707.707,0,0,1,39.469,23.987ZM6.656,20.05a.607.607,0,0,0-.606.606v2.625a.607.607,0,0,0,.606.606H39.469a.607.607,0,0,0,.606-.606V20.656a.607.607,0,0,0-.606-.606Zm32.206,2.625H7.262V21.263h31.6Zm-31.5-.1h31.4V21.362H7.363Z",
    transform: "translate(-6 -20)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3479",
    "data-name": "Grupo 3479",
    transform: "translate(2.625 15.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11002",
    "data-name": "Caminho 11002",
    d: "M7.656,46.969A.656.656,0,0,1,7,46.313V24.656a.656.656,0,0,1,1.313,0V46.313A.656.656,0,0,1,7.656,46.969Z",
    transform: "translate(-7 -24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11002_-_Contorno",
    "data-name": "Caminho 11002 - Contorno",
    d: "M7.656,47.019a.707.707,0,0,1-.706-.706V24.656a.706.706,0,1,1,1.413,0V46.313A.707.707,0,0,1,7.656,47.019Zm0-22.969a.607.607,0,0,0-.606.606V46.313a.606.606,0,1,0,1.212,0V24.656A.607.607,0,0,0,7.656,24.05Z",
    transform: "translate(-7 -24)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3480",
    "data-name": "Grupo 3480",
    transform: "translate(2.625 37.406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11003",
    "data-name": "Caminho 11003",
    d: "M10.938,61.594A3.941,3.941,0,0,1,7,57.656a.656.656,0,0,1,1.313,0,2.628,2.628,0,0,0,2.625,2.625.656.656,0,0,1,0,1.313Z",
    transform: "translate(-7 -57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11003_-_Contorno",
    "data-name": "Caminho 11003 - Contorno",
    d: "M10.938,61.644A3.992,3.992,0,0,1,6.95,57.656a.706.706,0,0,1,1.412,0,2.578,2.578,0,0,0,2.575,2.575.706.706,0,0,1,0,1.413ZM7.656,57.05a.607.607,0,0,0-.606.606,3.892,3.892,0,0,0,3.887,3.888.606.606,0,1,0,0-1.212,2.678,2.678,0,0,1-2.675-2.675A.607.607,0,0,0,7.656,57.05Z",
    transform: "translate(-7 -57)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3481",
    "data-name": "Grupo 3481",
    transform: "translate(34.125 15.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11004",
    "data-name": "Caminho 11004",
    d: "M55.656,46.969A.656.656,0,0,1,55,46.313V24.656a.656.656,0,0,1,1.313,0V46.313A.656.656,0,0,1,55.656,46.969Z",
    transform: "translate(-55 -24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11004_-_Contorno",
    "data-name": "Caminho 11004 - Contorno",
    d: "M55.656,47.019a.707.707,0,0,1-.706-.706V24.656a.706.706,0,1,1,1.412,0V46.313A.707.707,0,0,1,55.656,47.019Zm0-22.969a.607.607,0,0,0-.606.606V46.313a.606.606,0,0,0,1.213,0V24.656A.607.607,0,0,0,55.656,24.05Z",
    transform: "translate(-55 -24)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3482",
    "data-name": "Grupo 3482",
    transform: "translate(30.844 37.406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11005",
    "data-name": "Caminho 11005",
    d: "M50.656,61.594a.656.656,0,0,1,0-1.312,2.628,2.628,0,0,0,2.625-2.625.656.656,0,0,1,1.313,0A3.941,3.941,0,0,1,50.656,61.594Z",
    transform: "translate(-50 -57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11005_-_Contorno",
    "data-name": "Caminho 11005 - Contorno",
    d: "M50.656,61.644a.706.706,0,0,1,0-1.413,2.578,2.578,0,0,0,2.575-2.575.706.706,0,0,1,1.413,0A3.992,3.992,0,0,1,50.656,61.644Zm3.281-4.594a.607.607,0,0,0-.606.606,2.678,2.678,0,0,1-2.675,2.675.606.606,0,0,0,0,1.212,3.892,3.892,0,0,0,3.888-3.888A.607.607,0,0,0,53.938,57.05Z",
    transform: "translate(-50 -57)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3483",
    "data-name": "Grupo 3483",
    transform: "translate(5.906 40.688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11006",
    "data-name": "Caminho 11006",
    d: "M37.594,63.313H12.656a.656.656,0,0,1,0-1.312H37.594a.656.656,0,0,1,0,1.313Z",
    transform: "translate(-12 -62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11006_-_Contorno",
    "data-name": "Caminho 11006 - Contorno",
    d: "M37.594,63.362H12.656a.706.706,0,1,1,0-1.412H37.594a.706.706,0,0,1,0,1.412ZM12.656,62.05a.606.606,0,0,0,0,1.213H37.594a.606.606,0,0,0,0-1.213Z",
    transform: "translate(-12 -62)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3484",
    "data-name": "Grupo 3484",
    transform: "translate(1.313 17.719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11007",
    "data-name": "Caminho 11007",
    d: "M6.969,28.313H5.656a.656.656,0,0,1,0-1.312H6.969a.656.656,0,0,1,0,1.313Z",
    transform: "translate(-5 -27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11007_-_Contorno",
    "data-name": "Caminho 11007 - Contorno",
    d: "M6.969,28.362H5.656a.706.706,0,1,1,0-1.412H6.969a.706.706,0,1,1,0,1.412ZM5.656,27.05a.606.606,0,0,0,0,1.213H6.969a.606.606,0,0,0,0-1.213Z",
    transform: "translate(-5 -27)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3485",
    "data-name": "Grupo 3485",
    transform: "translate(34.126 17.719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11008",
    "data-name": "Caminho 11008",
    d: "M56.969,28.313H55.657a.656.656,0,0,1,0-1.312h1.312a.656.656,0,0,1,0,1.313Z",
    transform: "translate(-55.001 -27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11008_-_Contorno",
    "data-name": "Caminho 11008 - Contorno",
    d: "M56.969,28.362H55.657a.706.706,0,1,1,0-1.412h1.312a.706.706,0,1,1,0,1.412ZM55.657,27.05a.606.606,0,1,0,0,1.213h1.312a.606.606,0,0,0,0-1.213Z",
    transform: "translate(-55.001 -27)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3486",
    "data-name": "Grupo 3486",
    transform: "translate(0 5.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11009",
    "data-name": "Caminho 11009",
    d: "M3.656,20.469A.656.656,0,0,1,3,19.813V8.656a.656.656,0,0,1,1.313,0V19.813A.656.656,0,0,1,3.656,20.469Z",
    transform: "translate(-3 -8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11009_-_Contorno",
    "data-name": "Caminho 11009 - Contorno",
    d: "M3.656,20.519a.707.707,0,0,1-.706-.706V8.656a.706.706,0,0,1,1.413,0V19.813A.707.707,0,0,1,3.656,20.519Zm0-12.469a.607.607,0,0,0-.606.606V19.813a.606.606,0,0,0,1.212,0V8.656A.607.607,0,0,0,3.656,8.05Z",
    transform: "translate(-3 -8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3487",
    "data-name": "Grupo 3487"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11010",
    "data-name": "Caminho 11010",
    d: "M3.656,6.563A.656.656,0,0,1,3,5.906,5.913,5.913,0,0,1,8.906,0a.656.656,0,0,1,0,1.313A4.6,4.6,0,0,0,4.313,5.906.656.656,0,0,1,3.656,6.563Z",
    transform: "translate(-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11010_-_Contorno",
    "data-name": "Caminho 11010 - Contorno",
    d: "M3.656,6.613a.707.707,0,0,1-.706-.706A5.963,5.963,0,0,1,8.906-.05a.706.706,0,1,1,0,1.412A4.549,4.549,0,0,0,4.363,5.906.707.707,0,0,1,3.656,6.613ZM8.906.05A5.863,5.863,0,0,0,3.05,5.906a.606.606,0,0,0,1.212,0A4.649,4.649,0,0,1,8.906,1.263a.606.606,0,0,0,0-1.213Z",
    transform: "translate(-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3488",
    "data-name": "Grupo 3488",
    transform: "translate(36.75 5.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11011",
    "data-name": "Caminho 11011",
    d: "M59.656,20.469A.656.656,0,0,1,59,19.813V8.656a.656.656,0,0,1,1.313,0V19.813A.656.656,0,0,1,59.656,20.469Z",
    transform: "translate(-59 -8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11011_-_Contorno",
    "data-name": "Caminho 11011 - Contorno",
    d: "M59.656,20.519a.707.707,0,0,1-.706-.706V8.656a.706.706,0,1,1,1.412,0V19.813A.707.707,0,0,1,59.656,20.519Zm0-12.469a.607.607,0,0,0-.606.606V19.813a.606.606,0,0,0,1.213,0V8.656A.607.607,0,0,0,59.656,8.05Z",
    transform: "translate(-59 -8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3489",
    "data-name": "Grupo 3489",
    transform: "translate(31.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11012",
    "data-name": "Caminho 11012",
    d: "M56.906,6.563a.656.656,0,0,1-.656-.656,4.6,4.6,0,0,0-4.594-4.594.656.656,0,0,1,0-1.312,5.913,5.913,0,0,1,5.906,5.906A.656.656,0,0,1,56.906,6.563Z",
    transform: "translate(-51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11012_-_Contorno",
    "data-name": "Caminho 11012 - Contorno",
    d: "M56.906,6.613a.707.707,0,0,1-.706-.706,4.549,4.549,0,0,0-4.544-4.544.706.706,0,0,1,0-1.412,5.963,5.963,0,0,1,5.956,5.956A.707.707,0,0,1,56.906,6.613ZM51.656.05a.606.606,0,1,0,0,1.213A4.649,4.649,0,0,1,56.3,5.906a.606.606,0,0,0,1.213,0A5.863,5.863,0,0,0,51.656.05Z",
    transform: "translate(-51)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3490",
    "data-name": "Grupo 3490",
    transform: "translate(5.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11013",
    "data-name": "Caminho 11013",
    d: "M14.938,1.313H11.656a.656.656,0,0,1,0-1.312h3.281a.656.656,0,0,1,0,1.313Z",
    transform: "translate(-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11013_-_Contorno",
    "data-name": "Caminho 11013 - Contorno",
    d: "M14.938,1.362H11.656a.706.706,0,1,1,0-1.412h3.281a.706.706,0,1,1,0,1.412ZM11.656.05a.606.606,0,0,0,0,1.213h3.281a.606.606,0,0,0,0-1.213Z",
    transform: "translate(-11)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3491",
    "data-name": "Grupo 3491",
    transform: "translate(28.219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11014",
    "data-name": "Caminho 11014",
    d: "M49.938,1.313H46.656a.656.656,0,0,1,0-1.312h3.281a.656.656,0,0,1,0,1.313Z",
    transform: "translate(-46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11014_-_Contorno",
    "data-name": "Caminho 11014 - Contorno",
    d: "M49.938,1.362H46.656a.706.706,0,0,1,0-1.412h3.281a.706.706,0,1,1,0,1.412ZM46.656.05a.606.606,0,0,0,0,1.213h3.281a.606.606,0,1,0,0-1.213Z",
    transform: "translate(-46)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3492",
    "data-name": "Grupo 3492",
    transform: "translate(8.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11015",
    "data-name": "Caminho 11015",
    d: "M16.656,3.281A.656.656,0,0,1,16,2.625V.656a.656.656,0,0,1,1.313,0V2.625A.656.656,0,0,1,16.656,3.281Z",
    transform: "translate(-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11015_-_Contorno",
    "data-name": "Caminho 11015 - Contorno",
    d: "M16.656,3.331a.707.707,0,0,1-.706-.706V.656a.706.706,0,1,1,1.412,0V2.625A.707.707,0,0,1,16.656,3.331Zm0-3.281a.607.607,0,0,0-.606.606V2.625a.606.606,0,0,0,1.213,0V.656A.607.607,0,0,0,16.656.05Z",
    transform: "translate(-16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3493",
    "data-name": "Grupo 3493",
    transform: "translate(8.531 1.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11016",
    "data-name": "Caminho 11016",
    d: "M36.344,4.313H16.656a.656.656,0,0,1,0-1.312H36.344a.656.656,0,0,1,0,1.313Z",
    transform: "translate(-16 -3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11016_-_Contorno",
    "data-name": "Caminho 11016 - Contorno",
    d: "M36.344,4.363H16.656a.706.706,0,1,1,0-1.413H36.344a.706.706,0,0,1,0,1.413ZM16.656,3.05a.606.606,0,1,0,0,1.212H36.344a.606.606,0,1,0,0-1.212Z",
    transform: "translate(-16 -3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3494",
    "data-name": "Grupo 3494",
    transform: "translate(8.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11017",
    "data-name": "Caminho 11017",
    d: "M36.344,1.313H16.656a.656.656,0,0,1,0-1.312H36.344a.656.656,0,0,1,0,1.313Z",
    transform: "translate(-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11017_-_Contorno",
    "data-name": "Caminho 11017 - Contorno",
    d: "M36.344,1.362H16.656a.706.706,0,1,1,0-1.412H36.344a.706.706,0,0,1,0,1.412ZM16.656.05a.606.606,0,1,0,0,1.213H36.344a.606.606,0,1,0,0-1.213Z",
    transform: "translate(-16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3495",
    "data-name": "Grupo 3495",
    transform: "translate(28.219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11018",
    "data-name": "Caminho 11018",
    d: "M46.656,3.281A.656.656,0,0,1,46,2.625V.656a.656.656,0,0,1,1.313,0V2.625A.656.656,0,0,1,46.656,3.281Z",
    transform: "translate(-46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11018_-_Contorno",
    "data-name": "Caminho 11018 - Contorno",
    d: "M46.656,3.331a.707.707,0,0,1-.706-.706V.656a.706.706,0,1,1,1.412,0V2.625A.707.707,0,0,1,46.656,3.331Zm0-3.281a.607.607,0,0,0-.606.606V2.625a.606.606,0,0,0,1.213,0V.656A.607.607,0,0,0,46.656.05Z",
    transform: "translate(-46)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3496",
    "data-name": "Grupo 3496",
    transform: "translate(0 16.406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11019",
    "data-name": "Caminho 11019",
    d: "M4.969,27.625A1.971,1.971,0,0,1,3,25.656a.656.656,0,0,1,1.313,0,.656.656,0,0,0,.656.656.656.656,0,0,1,0,1.313Z",
    transform: "translate(-3 -25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11019_-_Contorno",
    "data-name": "Caminho 11019 - Contorno",
    d: "M4.969,27.675A2.021,2.021,0,0,1,2.95,25.656a.706.706,0,0,1,1.413,0,.607.607,0,0,0,.606.606.706.706,0,1,1,0,1.412ZM3.656,25.05a.607.607,0,0,0-.606.606,1.921,1.921,0,0,0,1.919,1.919.606.606,0,0,0,0-1.213.707.707,0,0,1-.706-.706A.607.607,0,0,0,3.656,25.05Z",
    transform: "translate(-3 -25)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3497",
    "data-name": "Grupo 3497",
    transform: "translate(35.438 16.406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11020",
    "data-name": "Caminho 11020",
    d: "M57.656,27.625a.656.656,0,0,1,0-1.312.656.656,0,0,0,.656-.656.656.656,0,0,1,1.313,0A1.971,1.971,0,0,1,57.656,27.625Z",
    transform: "translate(-57 -25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11020_-_Contorno",
    "data-name": "Caminho 11020 - Contorno",
    d: "M57.656,27.675a.706.706,0,1,1,0-1.412.607.607,0,0,0,.606-.606.706.706,0,1,1,1.412,0A2.021,2.021,0,0,1,57.656,27.675Zm1.313-2.625a.607.607,0,0,0-.606.606.707.707,0,0,1-.706.706.606.606,0,0,0,0,1.213,1.921,1.921,0,0,0,1.919-1.919A.607.607,0,0,0,58.969,25.05Z",
    transform: "translate(-57 -25)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3498",
    "data-name": "Grupo 3498",
    transform: "translate(9.844 19.688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11021",
    "data-name": "Caminho 11021",
    d: "M27.188,48.375a9.188,9.188,0,1,1,9.188-9.187A9.2,9.2,0,0,1,27.188,48.375Zm0-17.062a7.875,7.875,0,1,0,7.875,7.875A7.884,7.884,0,0,0,27.188,31.313Z",
    transform: "translate(-18 -30)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11021_-_Contorno",
    "data-name": "Caminho 11021 - Contorno",
    d: "M27.188,48.425a9.237,9.237,0,1,1,9.237-9.237A9.248,9.248,0,0,1,27.188,48.425Zm0-18.375a9.138,9.138,0,1,0,9.138,9.138A9.148,9.148,0,0,0,27.188,30.05Zm0,17.062a7.925,7.925,0,1,1,7.925-7.925A7.934,7.934,0,0,1,27.188,47.112Zm0-15.75a7.825,7.825,0,1,0,7.825,7.825A7.834,7.834,0,0,0,27.188,31.362Z",
    transform: "translate(-18 -30)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3499",
    "data-name": "Grupo 3499",
    transform: "translate(16.406 22.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11022",
    "data-name": "Caminho 11022",
    d: "M30.625,41.568A2.628,2.628,0,0,1,28,38.943c0-1.274,1.78-3.323,2.137-3.72a.678.678,0,0,1,.976,0c.357.4,2.137,2.446,2.137,3.72A2.628,2.628,0,0,1,30.625,41.568Zm0-4.89a5.879,5.879,0,0,0-1.312,2.265,1.313,1.313,0,0,0,2.625,0A5.879,5.879,0,0,0,30.625,36.677Z",
    transform: "translate(-28 -35.016)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11022_-_Contorno",
    "data-name": "Caminho 11022 - Contorno",
    d: "M30.625,41.618a2.678,2.678,0,0,1-2.675-2.675c0-1.3,1.791-3.354,2.15-3.753a.728.728,0,0,1,1.051,0c.359.4,2.15,2.46,2.15,3.753A2.678,2.678,0,0,1,30.625,41.618Zm0-6.552a.6.6,0,0,0-.451.191c-.355.394-2.124,2.426-2.124,3.686a2.575,2.575,0,0,0,5.15,0c0-1.257-1.769-3.291-2.124-3.686A.6.6,0,0,0,30.625,35.066Zm0,5.24a1.364,1.364,0,0,1-1.362-1.362,6.012,6.012,0,0,1,1.323-2.3l.039-.049.039.049a6.012,6.012,0,0,1,1.323,2.3A1.364,1.364,0,0,1,30.625,40.305Zm0-3.548a5.6,5.6,0,0,0-1.263,2.185,1.263,1.263,0,0,0,2.525,0A5.6,5.6,0,0,0,30.625,36.758Z",
    transform: "translate(-28 -35.016)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3500",
    "data-name": "Grupo 3500",
    transform: "translate(15.094 30.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11023",
    "data-name": "Caminho 11023",
    d: "M33.219,48.313H26.656a.656.656,0,0,1,0-1.312h6.563a.656.656,0,0,1,0,1.313Z",
    transform: "translate(-26 -47)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11023_-_Contorno",
    "data-name": "Caminho 11023 - Contorno",
    d: "M33.219,48.362H26.656a.706.706,0,0,1,0-1.412h6.563a.706.706,0,0,1,0,1.412ZM26.656,47.05a.606.606,0,1,0,0,1.213h6.563a.606.606,0,0,0,0-1.213Z",
    transform: "translate(-26 -47)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3501",
    "data-name": "Grupo 3501",
    transform: "translate(16.406 32.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11024",
    "data-name": "Caminho 11024",
    d: "M32.594,51.313H28.656a.656.656,0,0,1,0-1.312h3.938a.656.656,0,0,1,0,1.313Z",
    transform: "translate(-28 -50)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11024_-_Contorno",
    "data-name": "Caminho 11024 - Contorno",
    d: "M32.594,51.362H28.656a.706.706,0,0,1,0-1.412h3.938a.706.706,0,0,1,0,1.412ZM28.656,50.05a.606.606,0,1,0,0,1.213h3.938a.606.606,0,0,0,0-1.213Z",
    transform: "translate(-28 -50)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.69e0b9318ee23f1658ed0e9becd0d7d1.svg";
export { ForwardRef as ReactComponent };